<template>
  <div class="InvitationForm">
    <div class="InvitationInput">
      <lm-email-multiple ref="emailMultipleInput" required @submit="submit" />
    </div>
    <lm-button
      class="InvitationButton"
      :loading="submitting"
      mini
      @click="submit"
    >
      Send invitations
    </lm-button>
  </div>
</template>

<script>
import LmButton from '@/components/ui/LmButton'
import LmEmailMultiple from '@/components/form/LmEmailMultiple'

export default {
  name: 'InvitationForm',
  components: {LmButton, LmEmailMultiple},
  data() {
    return {
      submitting: false
    }
  },
  methods: {
    submit() {
      const emails = this.$refs.emailMultipleInput.getEmails()
      if (emails) {
        this.submitting = true
        this.$store.dispatch('inviteUsers', emails).then(
          () => {
            this.submitting = false
            this.$refs.emailMultipleInput.clear()
            this.$emit('update', emails)
          },
          error => {
            this.submitting = false
            this.$emit('error', error)
            console.log('InviteUsers Fail =>', error)
          }
        )
      }
    },
    clearErrors() {
      this.$refs.emailMultipleInput.clearErrors()
    }
  }
}
</script>

<style>
.InvitationForm {
  display: flex;
  align-items: flex-start;
  width: 100%;
  .InvitationInput {
    flex-grow: 2;
    margin-bottom: 0;
  }
  .InvitationButton {
    margin-left: 30px;
  }
  @media (max-width: 500px) {
    display: block;
    height: auto;
    .InvitationButton {
      width: 100%;
      margin: 10px 0;
    }
  }
}
.InvitationInput input:focus {
  outline: none;
  border: none; /* override global */
  border-bottom: 1px solid theme('colors.gray.900');
}
</style>
